var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8a1.198 1.198 0 00-1.2-1.205H9.21V1.184a1.207 1.207 0 00-.358-.838 1.198 1.198 0 00-2.042.838v5.611H1.221a1.196 1.196 0 00-1.128.74 1.209 1.209 0 00.662 1.584c.148.06.307.089.466.086h5.59v5.611a1.198 1.198 0 002.4 0V9.205H14.8c.318 0 .623-.127.848-.353.226-.226.352-.533.352-.852z",
    fill: "#1B143C"
  })));
}
export default SvgPlus;